<template>
  <v-card>
    <v-card-title>
      {{  $t('uploads.dialog.title', { file }) }}
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-container fluid mx-0 px-0>
      <data-table-scroll-hint>
        <v-data-table
          :headers="headers"
          :items="itemData.rows"
          item-key="nblrow"
          :page.sync="currentPage"
          :items-per-page.sync="itemsPerPage"
          :footer-props="footerProps"
          class="uploaded-file-table"
          :loading="isLoading"
        >
        </v-data-table>
      </data-table-scroll-hint>
    </v-container>
  </v-card>
</template>

<script>
import DataTableScrollHint from '@/components/common/DataTableScrollHint.vue';

export default {
  name: 'UploadedFile',
  components: { DataTableScrollHint },
  props: {
    nb1id: {
      type: String,
      required: true
    },
    file: {
      type: String,
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    currentPage: 1,
    itemsPerPage: 100,
    headers: [
      { text: 'Rad', value: 'nblrow', width: '50px'},
      { text: 'Status', value: 'nblstat', width: '50px' },
      { text: 'Text', value: 'nblstxt', width: '250px'  },
      { text: 'Parameter', value: 'nblparm' },
    ],
    itemData: {}
  }),

  watch: {
    nb1id() {
      this.fetchData()
    },
  },

  mounted() {
    this.fetchData()
  },

  computed: {
    footerProps() {
      return { itemsPerPageOptions: this.$vuetify.breakpoint.mobile ? [] : [50, 100, 200, 500, 2000, 5000] }
    },
  },
  methods: {
    fetchData() {
      this.isLoading = true
      this.$store.dispatch('app/getStagingFile', {nb1id: this.nb1id})
        .then((res) => {
          this.itemData = res.data
        })
        .finally(() => {
          this.isLoading = false
        })

    }
  }

}
</script>

<style scoped>
</style>